import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getApiKey } from "../../helpers/Utils";

const PrivateRoute: React.FC = () => {
  const apiKey = getApiKey()

  // If no API key is present in local storage, redirect to the login screen
  return apiKey ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;